module.exports = __webpack_public_path__ + "static/media/nf.82cb457a.svg";